import baseApi from "../api/baseApi";

const enrollmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllEnrollments: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        dateRange,
        category,
        courseId,
        type,
        status,
        isSessionAssigned,
      } = {}) => {
        const paramsObj = {
          page: String(page),
          limit: String(limit),
        };

        if (search) paramsObj.search = search;
        if (dateRange) paramsObj.dateRange = dateRange;
        if (category) paramsObj.category = category;
        if (courseId) paramsObj.courseId = courseId;
        if (type) paramsObj.type = type;
        if (status) paramsObj.status = status;
        if (typeof isSessionAssigned !== "undefined") {
          paramsObj.isSessionAssigned = String(isSessionAssigned);
        }

        return {
          url: `/enrollment/admin/getAllEnrollments?${new URLSearchParams(paramsObj).toString()}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["Enrollments"],
    }),
    updateEnrollmentStatus: builder.mutation({
      query: ({ id, status = "Approved" }) => ({
        url: `/enrollment/admin/updateEnrollmentStatus/${id}`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["Enrollments"],
    }),
    createCourseSession: builder.mutation({
      query: ({
        enrollmentId,
        instructorId,
        sessionDate,
        startTime,
        endTime,
        sessionLink,
        notes,
      }) => ({
        url: "/coursesession/createSession",
        method: "POST",
        credentials: "include",
        body: {
          enrollmentId,
          instructorId,
          sessionDate,
          startTime,
          endTime,
          ...(sessionLink && { sessionLink }),
          ...(notes && { notes }),
        },
      }),
      invalidatesTags: ["Enrollments", "CourseSessions"],
    }),
  }),
});

export const {
  useGetAllEnrollmentsQuery,
  useUpdateEnrollmentStatusMutation,
  useCreateCourseSessionMutation,
} = enrollmentApi;
